<template>
  <div style="height: 100vh">
    <vue-element-loading
      is-full-screen
      :active="loading"
      spinner="bar-fade-scale"
      color="#152d51"
    />
    <div v-if="!loading">
      <div class="bg-blue col-12" style="height:100px;"></div>
      <div class="text-center" style="margin-top:-70px">
        <v-avatar class="border-avatar" width="35vw" height="35vw">
          <img :src="img" />
        </v-avatar>
      </div>
      <div class="text-center mt-5" style="font-weight: bold;">{{ profile.displayName }}</div>
      <div class="px-5" v-if="!hasEtaxBill" style="margin-top: 20px">
        <v-layout align-center class="px-3 py-4" style="background:#F2F2F2; border-radius: 10px">
          <v-flex class="pr-2 caption">
            <strong>
              คุณยังไม่ได้ลงทะเบียนรับ E-Tax
            </strong>
            <div style="color: #817F7F">
              สำหรับรับใบแจ้งหนี้/ใบเสร็จ/ใบกำกับภาษีอิเล็กทรอนิกส์ผ่านไลน์
            </div>
          </v-flex>
          <v-flex shrink>
            <v-btn
              color="primary"
              large
              small
              style="color:white;min-width:50%"
              rounded
              :href="linkToEtaxBill"
              >กดเปิดใช้งาน</v-btn
            >
          </v-flex>
        </v-layout>
      </div>

      <div class="px-5" v-else style="margin-top: 20px">
        <v-layout align-center class="px-3 py-4" style="background:#F2F2F2; border-radius: 10px">
          <v-flex class="pr-2 caption">
            <strong>
              ลงทะเบียนรับ E-Tax
            </strong>
            <div style="color: #817F7F">
              สำหรับรับใบแจ้งหนี้/ใบเสร็จ/ใบกำกับภาษีอิเล็กทรอนิกส์ผ่านไลน์
            </div>
          </v-flex>
          <v-flex shrink>
            <v-btn color="#5BCF00" large small style="color:white;min-width:50%" rounded readonly
              >เปิดใช้งาน</v-btn
            >
          </v-flex>
        </v-layout>
      </div>

      <div v-if="userData && userData.cardnumber">
        <div class="mt-8  px-5">
          <div v-if="loading" class="py-15"></div>
          <div v-if="showData && showData.length">
            <div
              class="item-contact text-blue mb-4 d-flex justify-content-between"
              v-for="(item, index) in showData"
              :key="`contact-list-${index}`"
              @click="
                $store.dispatch('setContact', item)
                selectData = item
                show = true
              "
            >
              <span>
                <v-icon class="text-blue">mdi-file-document-edit-outline</v-icon> เลขที่สัญญา
                {{ item.agreementNo ? item.agreementNo : '-' }}
              </span>
              <span
                ><v-btn outlined icon color="#23409a" x-small
                  ><span class="fs-17" style="margin-left: 3px;"
                    ><v-img
                      style="width:9px;height:auto"
                      src="@/assets/vector.svg"
                    ></v-img></span></v-btn
              ></span>
            </div>
          </div>
          <div v-else>
            <div class="text-center mt-7">
              สัญญาอยู่ระหว่างดำเนินการ
            </div>
          </div>
        </div>

        <div class="flex-all-center mt-8">
          <v-btn
            :loading="loading || loadingCancel"
            @click="cancelRegis"
            class=" px-8 main-btn"
            style="color:white;"
            color="#FD4337"
            >ยกเลิกบริการลงทะเบียนใช้งานกับไลน์</v-btn
          >
        </div>
        <div class="flex-all-center">
          <div style="color:red;padding:12px" class="fs-13 col-10 text-center">
            *หากยกเลิกบริการ Next Connect จะไม่สามารถรับข้อมูลและการสอบถามข้อมูล
            สินเชื่อผ่านช่องทางนี้ได้
          </div>
        </div>
      </div>
      <div v-else>
        <div class="text-center mt-7">
          กรุณาลงทะเบียนก่อนการใช้บริการนี้ครับ
        </div>
        <div class="flex-all-center mt-5">
          <v-btn
            color="primary"
            large
            style="color:white;min-width:50%"
            class="main-btn"
            @click="$router.push('/regis')"
            >ลงทะเบียน</v-btn
          >
        </div>
      </div>
      <v-dialog
        v-model="show"
        scrollable
        fullscreen
        persistent
        max-width="500px"
        transition="dialog-bottom-transition"
      >
        <v-card class="py-2 px-5">
          <v-toolbar
            dark
            class="position-fixed col-12"
            style="height: 56px; top: 0; z-index: 2"
            color="#23409a"
          >
            <v-btn icon dark @click="show = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <div style="margin-top:80px;background-color:white">
            <div class="mb-3 flex-all-center">
              <div>
                <v-img
                  class="radius-circle"
                  style="width:100px;height:auto"
                  src="@/assets/logo_h.png"
                ></v-img>
              </div>
            </div>
            <h6 class="pl-5 text-blue mb-8" v-if="selectData && selectData.model">
              รายละเอียดสัญญาเลขที่ {{ selectData.agreementNo }}
            </h6>
            <ContractTable v-if="selectData && selectData.model" :showData="selectData" />
            <div class="mb-5 w-100 flex-all-center">
              <v-btn
                @click="$router.push('/paymentgenerate')"
                large
                class="main-btn"
                style="color:white"
                color="#23409A"
                >ขอบาร์โค้ด/คิวอาร์โค้ดเพื่อชำระเงิน</v-btn
              >
            </div>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import ContractTable from '@/components/contractTable.vue'
import VueElementLoading from 'vue-element-loading'
import config from '@/config'
import { formatThaiDate } from '@/utils/dateFormat'

export default {
  components: { ContractTable, VueElementLoading },
  data() {
    return {
      loading: true,
      loadingMain: true,
      loadingCancel: false,
      show: false,
      selectData: null,
      showData: null,
      userData: null,
      hasEtaxBill: false
    }
  },
  mounted() {},
  watch: {
    userId: {
      immediate: true,
      handler(userId) {
        if (userId) {
          this.setup()
        }
      }
    }
  },
  methods: {
    async setup() {
      await this.fetchUserData(this.userId)
      await this.fetchContact()
      this.loading = false
      this.loadingMain = false
    },
    async cancelRegis() {
      let result = await this.$swal.fire({
        title: 'ต้องการยกเลิกบริการลงทะเบียนใช้งานกับไลน์',
        text: this.hasEtaxBill
          ? 'รับใบแจ้งหนี้/ใบเสร็จ/ใบกำกับภาษีจะถูกจัดส่งให้คุณทางไปรษณีย์ ยกเว้นเอกสารที่ ณ ปัจจุบันมีสถานะรอจัดส่งแล้ว จะยังคงส่งที่บัญชีไลน์นี้'
          : 'คุณจะไม่สามารถรับการแจ้งเตือนข้อมูลและข่าวสารผ่านช่องทางไลน์ได้อีก',
        type: 'question',
        showCancelButton: true,
        confirmButtonText: 'ต้องการ',
        cancelButtonText: 'ไม่ต้องการ',
        customClass: {
          header: 'header-class',
          title: 'fs-19',
          content: 'fs-16',
          confirmButton: 'main-btn col-5 m-0 myred',
          cancelButton: 'main-btn col-6 m-0 mysilver',
          actions: 'p-0 w-100 d-flex flex-row justify-content-between'
        }
      })
      if (result.value) {
        this.loadingCancel = true
        let body = {
          userId: this.userId,
          idCard: this.userData.cardnumber,
          pageid: config.pageid,
          etaxebill: this.hasEtaxBill ? 'regis' : 'unregis',
          canceletaxebill: this.hasEtaxBill ? true : false
        }
        let res = await api.unbind(body)
        if (res.responsecode == 204) {
          this.loadingCancel = false
          this.$router.push('unlinkdone')
        } else {
          this.loadingCancel = false
          this.$swal.fire({
            text: 'ยกเลิกบริการไม่สำเร็จ',
            type: 'error'
          })
        }
      }
    },
    async fetchUserData(userId) {
      if (userId) {
        let res = await api.getUser(userId)
        if (res.responsecode == 200 && res.data.id) {
          this.userData = res.data
          this.$store.state.userData = res.data
        } else {
          console.log('error fetch user data')
        }
      }
    },
    async fetchContact() {
      let body = {
        IDCard: this.userData.cardnumber,
        BirthDay: formatThaiDate(this.userData.dob),
        pageid: config.pageid
      }
      let res = await api.getContact(body)
      if (res && res.responsecode == 200) {
        this.showData = res.data
        if (this.showData && this.showData.length > 0 && this.showData[0].etaxebill == 'regis') {
          this.hasEtaxBill = true
        }
      } else {
        // this.$router.push("/regis");
      }
    }
  },
  computed: {
    linkToEtaxBill() {
      return this.$store.getters.getLinkEtax
    },
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    },
    img() {
      return this.$store.state.profile.pictureUrl
    },
    profile() {
      return this.$store.state.profile
    },
    userId() {
      return this.$store.getters.getUserid
    }
  }
}
</script>

<style>
.myred {
  background-color: rgb(253, 67, 55) !important;
}
.mysilver {
  background: #f5f5f5 !important;
  color: black !important;
}
.border-avatar {
  border: 4px solid white;
}
.slidedealer,
.slidedealer-back {
  &-enter-active,
  &-leave-active {
    position: absolute;
    width: 100%;
    background: white;
    min-height: 100vh;
    top: 12px;
  }
}
// router view
.slidedealer-enter-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(100%);
}
.slidedealer-enter-to {
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-leave-active {
  z-index: -1;
}
.slidedealer-leave-to {
  z-index: -1;
}
// router view back

.slidedealer-back-enter-active {
  z-index: -1;
}
.slidedealer-back-enter-to {
  z-index: -1;
}

.slidedealer-back-leave-active {
  transition: transform $duration ease-in-out;
  z-index: 2;
  transform: translateX(0%);
}
.slidedealer-back-leave-to {
  transform: translateX(100%);
  z-index: 2;
}
.addcartbtn {
  position: fixed;
  text-align: center;
  padding-top: 15px;
  z-index: 1;
  font-size: 23px;
  bottom: 0px;
  background-color: rgb(12, 77, 157);
  width: 90vw;
  height: 60px;
  color: white;
  border-radius: 13px 13px 0px 0px;
  left: 50%;
  transform: translate(-50%, 0);
}
.myshadow {
  -webkit-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.75);
  -moz-box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.65);
  box-shadow: 2px 3px 17px -1px rgba(0, 0, 0, 0.95);
}
.center {
  display: flex;
  align-items: center;
  justify-content: center;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}
</style>
